import { CountryCodeList } from '../../types/countries';
import { SiteLanguage, SiteNameSpace } from 'constants/locale';
import ZoocasaTheme from 'themes/zoocasa';

import type { ThemeConfig } from 'themes/themeConfig';
import type { Tenant } from '../types';

export const ZOOCASA_TENANT_ID = 'zoocasa' as const;
export const ZOOCASA_L18N_NAMESPACE = ZOOCASA_TENANT_ID;
export const ZOOCASA_L18N_NAMESPACES = [
  ZOOCASA_L18N_NAMESPACE,
  SiteNameSpace.Common,
  SiteNameSpace.FormError,
  SiteNameSpace.Modal,
] as const;

export const zoocasaTenant: Tenant<ThemeConfig> = {
  id: ZOOCASA_TENANT_ID,
  hosts: ['zoocasa.com', 'www.zoocasa.com'],
  theme: ZoocasaTheme,
  localization: {
    languages: [SiteLanguage.English, SiteLanguage.French],
    countries: [CountryCodeList.CANADA],
    namespaces: ZOOCASA_L18N_NAMESPACES,
  },
  config: {},
  debug: {},
  features: {
    MyLinkMyLead: false,
    AgentSearch: false,
  },
};